import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { FirmwareService } from '@core/services';
import { FirmwareActions } from '../actions/firmware.actions';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';

export const getFirmwareVersions$ = createEffect(
  (actions$ = inject(Actions), firmwareService = inject(FirmwareService)) => {
    return actions$.pipe(
      ofType(FirmwareActions.getFirmwareVersions),
      switchMap(({ filter }) => {
        return firmwareService.getFirmwareVersions(filter).pipe(
          map(items => FirmwareActions.getFirmwareVersionsSuccess({ items })),
          catchError(error => of(FirmwareActions.getFirmwareVersionsFailure({ error }))),
        );
      }),
    );
  },
  { functional: true },
);

export const deactivateFirmware$ = createEffect(
  (actions$ = inject(Actions), firmwareService = inject(FirmwareService)) => {
    return actions$.pipe(
      ofType(FirmwareActions.deactivateFirmware),
      switchMap(({ firmwareId }) => {
        return firmwareService.deactivateFirmware(firmwareId).pipe(
          map(response =>
            FirmwareActions.deactivateFirmwareSuccess({ firmwareId: response.firmwareId }),
          ),
          catchError(error => of(FirmwareActions.deactivateFirmwareFailure({ error }))),
        );
      }),
    );
  },
  { functional: true },
);

export const updateDeviceFirmware$ = createEffect(
  (actions$ = inject(Actions), firmwareService = inject(FirmwareService)) => {
    return actions$.pipe(
      ofType(FirmwareActions.updateDeviceFirmware),
      switchMap(({ request }) => {
        return firmwareService.updateDeviceFirmware(request).pipe(
          map(() => FirmwareActions.updateDeviceFirmwareSuccess()),
          catchError(error => of(FirmwareActions.updateDeviceFirmwareFailure({ error }))),
        );
      }),
    );
  },
  { functional: true },
);

export const startDlmsFirmwareUpdate$ = createEffect(
  (actions$ = inject(Actions), firmwareService = inject(FirmwareService)) => {
    return actions$.pipe(
      ofType(FirmwareActions.startDlmsFirmwareUpdate),
      switchMap(({ deviceId, firmwareId }) => {
        return firmwareService.startDlmsFirmwareUpdate(deviceId, { firmwareId }).pipe(
          map(response => FirmwareActions.startDlmsFirmwareUpdateSuccess({ response })),
          catchError(error => of(FirmwareActions.startDlmsFirmwareUpdateFailure({ error }))),
        );
      }),
    );
  },
  { functional: true },
);

export const bulkUpdateDeviceFirmware$ = createEffect(
  (actions$ = inject(Actions), firmwareService = inject(FirmwareService)) => {
    return actions$.pipe(
      ofType(FirmwareActions.bulkUpdateDeviceFirmware),
      switchMap(({ request }) => {
        return firmwareService.bulkUpdateDeviceFirmware(request).pipe(
          map(response => FirmwareActions.bulkUpdateDeviceFirmwareSuccess({ response })),
          catchError(error => of(FirmwareActions.bulkUpdateDeviceFirmwareFailure({ error }))),
        );
      }),
    );
  },
  { functional: true },
);

export const bulkStartDlmsFirmwareUpdate$ = createEffect(
  (actions$ = inject(Actions), firmwareService = inject(FirmwareService)) => {
    return actions$.pipe(
      ofType(FirmwareActions.bulkStartDlmsFirmwareUpdate),
      switchMap(({ request }) => {
        return firmwareService.startBulkDlmsFirmwareUpdate(request).pipe(
          map(response => FirmwareActions.bulkStartDlmsFirmwareUpdateSuccess({ response })),
          catchError(error => of(FirmwareActions.bulkStartDlmsFirmwareUpdateFailure({ error }))),
        );
      }),
    );
  },
  { functional: true },
);
